import { useCallback } from 'react'
import { createLogger } from '../../../app/logger'
import { CheckinEntry } from '../../../app/types'

// eslint-disable-next-line no-unused-vars
export const logger = createLogger({
  prefix: 'useEntrySort'
})

export default function useEntrySort(textSearch: string) {
  return useCallback((a: CheckinEntry, b: CheckinEntry) => {
    if (textSearch) {
      const isAlpha = isNaN(parseFloat(textSearch))
      if (isAlpha) {
        const textFields: (keyof CheckinEntry)[] = [
          'fullName',
          'firstName',
          'lastName',
          'teamName'
        ]

        for (const field of textFields) {
          const aValue = String(a[field]).toLowerCase()
          const bValue = String(b[field]).toLowerCase()
          const fullNameNonTeamMatch = field === 'fullName' && a.teamId === null
          if (fullNameNonTeamMatch) {
            if ((aValue === textSearch) && (bValue !== textSearch)) return 1
          }
          if ((aValue === textSearch) && (bValue !== textSearch)) return -1
          if ((bValue === textSearch) && (aValue !== textSearch)) return 1
        }
        return a.fullName?.localeCompare(b.fullName)
      }

      const numberFields: (keyof CheckinEntry)[] = [
        'entryId',
        'bib'
      ]

      for (const field of numberFields) {
        const aValue = Number(a[field])
        const bValue = Number(b[field])
        if ((aValue === +textSearch) && (bValue !== +textSearch)) return -1
        if ((bValue === +textSearch) && (aValue !== +textSearch)) return 1
      }
    }
    return +a.bib - +b.bib
  }, [textSearch])
}
